import * as t from 'io-ts';
import { fromEnum } from '../../responseUtil';
import { NonEmptyString } from 'io-ts-types';
import {
    ApiCategory,
    ApiFuelType,
    ApiVehicleType,
    CustomsInformationCodec,
    VehicleDimensionsCodec,
    VehicleIdCodec,
} from '../sharedVehicleApi.types';

export const ModelCodec = t.intersection([
    t.type({
        name: t.string,
        model_group: NonEmptyString,
    }),
    t.partial({
        version: t.string,
        category: fromEnum<ApiCategory>('ApiCategory', ApiCategory),
        manufacturer: t.string,
        fuel_type: fromEnum<ApiFuelType>('ApiFuelType', ApiFuelType),
    }),
]);

export enum ApiVehicleConditionType {
    NOT_ON_SITE = 'not-on-site',
    CONTACT_UNKNOWN = 'contact-unknown',
    NOT_READY_FOR_PICKUP = 'not-ready-for-pickup',
    NO_KEYS = 'no-keys',
    NOT_READY_TO_DRIVE = 'not-ready-to-drive',
    NOT_READY_TO_MOVE = 'not-ready-to-move',
    OTHER = 'other',
}

export const VehicleConditionTypeCodec = fromEnum<ApiVehicleConditionType>(
    'ApiVehicleConditionType',
    ApiVehicleConditionType,
);
export const VehicleCodec = t.intersection([
    t.type({
        id: VehicleIdCodec,
        model: ModelCodec,
    }),
    t.partial({
        weight: t.number,
        colour: t.string,
        dimensions: VehicleDimensionsCodec,
        vehicle_type: fromEnum<ApiVehicleType>('ApiVehicleType', ApiVehicleType),
        license_plate: t.string,
        special_instructions: t.array(NonEmptyString),
        delivery_condition: VehicleConditionTypeCodec,
        has_priority: t.boolean,
        manufactured_at: t.string,
        customs_information: CustomsInformationCodec,
    }),
]);
export type ApiVehicle = t.TypeOf<typeof VehicleCodec>;
export type ApiModel = t.TypeOf<typeof ModelCodec>;
